import { Component, Input, OnInit } from '@angular/core';
import { LMBuilderModel } from "@components/builder/services/lm-builder-model.service";
import { LMErrorUtilService } from "@app/services";

@Component({
  selector:    'lm-builder-report-categorization',
  standalone: false,
  templateUrl: './lm-builder-report-categorization.component.html',
  styleUrl: './lm-builder-report-categorization.component.scss',
})
export class LMBuilderReportCategorizationComponent implements OnInit {
  @Input() spec!: LMListPSpec;

  categories: Array<LMBuilderMetaDataOption> = [];
  subcategories: Array<LMBuilderMetaDataOption> = [];

  constructor(
      private lmBuilderModel: LMBuilderModel,
      private lmErrorUtilService: LMErrorUtilService,
  ) {
    // no-op
  }

  ngOnInit(): void {
    this.initialize();
  }

  private initialize() {
    if (this.spec.formReport) {
      this.categories = [ { value: this.spec.formReport.category, label: this.spec.formReport.categoryDisplay } ];
      this.subcategories = [ { value: this.spec.formReport.subcategory, label: this.spec.formReport.subcategoryLabel === '' ? Soho.Locale.translate('General') : this.spec.formReport.subcategoryLabel } ];
    }
  }

  categoryChanged() {
    if (this.spec.formReport) {
      this.spec.formReport.subcategory = '';
    }
  }

  onCategorySelect = (response: SohoDropDownResponseFunction) => {
    if (this.spec.formReport) {
      this.lmBuilderModel.getReportCategories(this.spec.formReport.category).subscribe({
        next: (v)         => { response(v);                   },
        error: (e)        => {
          this.handleError(e);
          response([]);
        },
        complete: ()      => {                                }
      });
    }
  };

  onSubcategorySelect = (response: SohoDropDownResponseFunction) => {
    if (this.spec.formReport) {
      this.lmBuilderModel.getReportSubcategories(this.spec.formReport.category, this.spec.formReport.subcategory).subscribe({
        next: (v)         => {
          response(v);
          this.subcategories = v;
        },
        error: (e)        => {
          this.handleError(e);
          response([]);
        },
        complete: ()      => {                                }
      });
    }
  };

  private handleError(error: any) {
    this.lmErrorUtilService.handleUnexpectedError(error);
  }
}
